import { faFilePdf, faPaperPlane, faPrint, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React,{useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import func from '../../services/functions';
import ThermalPrinterInvoiceContent from '../CustomInvoices/ThermalPrinterInvoiceContent';
import Accordion from '../CustomInvoices/WizardSteps/Accordion';
import useShowInvoicePdf from './useShowInvoicePdf';

const InvoicePrintInfo = ({invoice,preview}) => {
  const { t } = useTranslation("translations");
  const { showInvoicePdf,pdfEmbed,loadingPdf } = useShowInvoicePdf()


  useEffect(()=>{
    if(invoice?.status?.status === "APPROVED" &&  preview){
      handlePrint();
    }
  },[invoice.status?.status])

  const handlePrint = () => {

  
    const content = document.getElementById("thermalPrinterInvoice");
    const pri = document.getElementById("ifmcontentstoprint").contentWindow;
  
  
    pri.document.open();
    pri.document.write(`<html><style>@page{margin:0mm auto;margin-bottom:10mm;font-family: 'EB Garamond', serif;}</style>${content.innerHTML}</html>`);
    pri.document.close();
    pri.focus();
    pri.print();
    pri.document.close();

  }
  
  let badgeClass = "secondary";
  let statusLabel = "Draft";

  if(invoice){switch (invoice?.status?.status) {
      case "READY_FOR_APPROVAL":
        badgeClass = "info";
        statusLabel = "Ready For Approval";
      case "APPROVED":
        badgeClass = "success";
        statusLabel = "Approved";
         break;
       default:
    }
  }
  if(invoice.iic || invoice.eic || invoice.fic){
    return (<div className="card-accordion">
        
    <Accordion
      heading={
        <div className='d-flex align-items-center justify-content-around'>
          {invoice.iic && (
            <a
              href="#"
              className={
                "btn btn-sm btn-info d-flex-align-items-center"
              }
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handlePrint();
              }}
            >
              <FontAwesomeIcon icon={faPrint} className="mr-1" />
              Thermal Fisc
            </a>
          )}
          {invoice.iic && (
            <a
              href="#"
              className={
                "btn btn-sm btn-info d-flex-align-items-center" +
                (loadingPdf?.loading && loadingPdf?.key=="iic"  ? " disabled" : "")
              }
              onClick={(e) => {
                e.stopPropagation();
                showInvoicePdf({key:"iic", invoice,e});
              }}
            >
              <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
              Print Fisc
            </a>
          )}
        {invoice.eic && (
            <a
              href="#"
              className={
                "btn btn-sm btn-info d-flex-align-items-center" +
                (loadingPdf?.loading && loadingPdf?.key=="eic" ? " disabled" : "")
              }
              onClick={(e) => {
                e.stopPropagation();
                showInvoicePdf({key:"eic", invoice,e});
              }}
            >
              <FontAwesomeIcon icon={faFilePdf} className="mr-1" />
              Print Einv
            </a>
          )}
          {invoice.qrurl && (
            <a
              href={invoice.qrurl}
              onClick={(e) => e.stopPropagation()}
              className="btn btn-sm btn-info d-flex-align-items-center"
              target="_blank"
            >
              QR Url
            </a>
          )}
          {invoice.iic && (
            <a
              href="#"
              className="btn btn-sm btn-info d-flex-align-items-center"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                func.sendEmailPdf(invoice.iic, invoice.customer, invoice?.parties?.buyer?.tin, t);
              }}
            >
              <FontAwesomeIcon icon={faPaperPlane} className="mr-1" />
              Email
            </a>
          )}
        </div>
      }
    >
      <div style={{ padding: "10px 20px 20px" }}>
        <p>
          <strong>{t("invoice.FIC")}: </strong> {invoice.fic}
        </p>
        <p>
          <strong>{t("invoice.IIC")}: </strong> {invoice.iic}
        </p>
        <p>
          <strong>EIC: </strong> {invoice.eic}
        </p>
        <p>
          <strong>ERP ID: </strong> {invoice?.internalId ?? ""}
        </p>
        <p>
          <strong>{t("nslf.invoiceNumber")}: </strong> {invoice?.number ?? ""}
        </p>
      </div>
    </Accordion>
    <div className="d-none">
        {invoice?.action?.action === "APPROVED" && <ThermalPrinterInvoiceContent invoice={invoice} />}
     </div>
    <iframe id="ifmcontentstoprint" className="d-none"></iframe>
      {pdfEmbed}
  </div>)
  }
  return <></>
}

export default InvoicePrintInfo